import { EOrderStatus, TOrder } from '@/types/orders';

export const getStatusOrder = (order: TOrder): EOrderStatus => {
    /*
    Приоритезация типа статуса :
        Closed
        Sent to court
        Delayed
        Issued
        Approved
        Active
     */

    if (order?.status?.type.includes(EOrderStatus.Closed)) {
        return EOrderStatus.Closed;
    }

    if (order?.status?.type.includes(EOrderStatus.Sent_to_court)) {
        return EOrderStatus.Sent_to_court;
    }

    if (order?.status?.type.includes(EOrderStatus.Delayed)) {
        return EOrderStatus.Delayed;
    }

    if (order?.status?.type.includes(EOrderStatus.Issued)) {
        return EOrderStatus.Issued;
    }

    if (order?.status?.type.includes(EOrderStatus.Approved)) {
        return EOrderStatus.Approved;
    }

    if (order?.status?.type.includes(EOrderStatus.Active)) {
        return EOrderStatus.Active;
    }

    return EOrderStatus.Closed;
};
